import { createNullableContext } from '~/common/contexts/nullableContext';
import { IconRepositoryContextType } from './types/IconRepositoryContextType';

export const IconRepositoryContext =
  createNullableContext<IconRepositoryContextType>();
